// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".related-recipes .crd-image-tile .crd-image-tile__headline,.related-recipes .crd-image-tile .crd-image-tile__preline{text-shadow:0 2px 4px rgba(0,0,0,.5)!important;color:#fff!important}", ""]);
// Exports
module.exports = exports;
